//
//
//
//
//
//
//
//
//
//
//
//
//
import newUserPaid from "./roleOccupationPaymentRate/newUserPaid";
import levelPaymentAmount from "./roleOccupationPaymentRate/levelPaymentAmount";
import levelPaymentFrequency from "./roleOccupationPaymentRate/levelPaymentFrequency";
export default {
  name: "roleOccupationPaymentRate",
  components: {
    newUserPaid: newUserPaid,
    levelPaymentAmount: levelPaymentAmount,
    levelPaymentFrequency: levelPaymentFrequency
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'newUserPaid'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};